export const SHIMMER_CARD = {
  root: 'shimmer-card'
};
